import { type Router, createRouter, createWebHistory } from 'vue-router';
import IframeView from '@/views/IframeView.vue';
import LoginView from '@/views/LoginView.vue';
import { useAuthStore } from '@/stores/auth.store';
import GwtView from '@/views/GwtView.vue';
import { gwtBridge } from '@/GWTBridge';

var bridge: any;

gwtBridge.then((retBridge) => {
  bridge = retBridge;
});

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { path: '/rm4/Login.php' },
    },
    {
      path: '/login',
      component: LoginView,
      meta: { title: 'BrightSide Login' },
    },
    {
      path: '/notification-settings',
      name: 'NotificationSettings',
      component: () => import('@/views/NotificationSettings.vue'),
      meta: { title: 'Notification Settings' },
    },
    {
      path: '/gwt/:pathMatch(.*)*',
      component: GwtView
    },
    {
      path: '/rm4/:pathMatch(.*)*',
      name: 'rm4',
      component: IframeView,
      props: route => ({ src: route.fullPath.replace(/^\/rm4/, '/RM4') })
    },
    {
      path: '/inbox/:id?',
      component: () => import('@/views/InboxView.vue'),
      meta: { title: 'Inbox' },
    },
    {
      path: '/inbox/new/:reservationNumber?',
      component: () => import('@/views/InboxView.vue'),
      props: route => ({ 
        showNewMessage: true,
        reservationNumber: route.params.reservationNumber
      }),
      meta: { title: 'New Message' },
    },
    {
      path: '/reports',
      name: 'reports',
      children: [
        {
          path: 'source',
          name: 'Reservations By Source Report',
          component: () => import('@/reports/ReservationsBySource.vue')
        }
      ]
    }
  ],
});

router.beforeEach(async (to, from, next) => {
  // 1. Handle GWT and RM4 redirects
  if (to.path === '/gwt/' && to.hash.startsWith('#rm4')) {
    const remainingPath = to.hash.replace('#rm4', '').replace(/^\/+/, '');
    return next(`/rm4/${remainingPath}`);
  }
  if ((to.path === '/gwt/' || to.path === '/gwt') && to.hash.length === 0) {
    return next('/rm4/Login.php');
  }

  // 2. Check authentication
  const publicPages = ['/login', '/gwt/#timeclock', '/gwt/#maintenancecalendar/.*'];
  let authRequired = true;
  for (const page of publicPages) {
    const regex = new RegExp('^' + page + '$');
    if (regex.test(to.fullPath)) {
      authRequired = false;
      break;
    }
  }
  const auth = useAuthStore();
  if (authRequired && !auth.token) {
    auth.returnUrl = to.fullPath;
    return next('/login');
  }

  // 3. Handle GWT unsaved changes
  if (bridge && bridge.needSave()) {
    if (window.confirm('Changes have been made. Discard them?')) {
      bridge.clearNeedSave();
    } else {
      return next(false);
    }
  }

  // 4. Set page title
  if (to.meta?.title) {
    document.title = typeof to.meta.title === 'function' ? to.meta.title(to.params) : to.meta.title;
  } else if (to.name != 'rm4') {
    document.title = 'BrightSide';
  }

  next();
});

declare global {
  interface Window {
    vueRouter?: Router;
  }
}

window.vueRouter = router;

export default router;